(function () {
  'use strict';

  class VehicleRegistrationController {
    constructor($scope, $log, Authenticator, safetyService, FeatureOuService) {
      this.authenticator = Authenticator;
      this.log = $log;
      this.scope = $scope;
      this.safetyService = safetyService;
      this.FeatureOuService = FeatureOuService;
      this.initUserConfig();
      this.scope.$watch(() => this.shouldDisableRegisterVehicleButton(), (newVal) => {
        this.disableRegisterVehicleButton = newVal;
      });
    }

    loadReactComponent(props = {}) {
      const appName = 'safetyApp',
          componentPath = './VehicleRegistrationModal',
          componentId = 'vehicleRegistrationModal';
      return this.safetyService.initialize()
        .then(() => this.safetyService.loadReactComponent(appName, componentPath, componentId, props));
    }

    initUserConfig() {
      this.authenticator.getUser().then(user => {
        this.isAdministrator = this.isUserAdministrator(user.permissoes);
        this.language = user.idioma;
        this.getVehicleRegistrationConfig(user.uo.id);
      });
    }

    isUserAdministrator(permissoes) {
      const AdminProfiles = {
        NA_ADMIN: 'VEICULO_EDITAR'
      };
      return permissoes.includes(AdminProfiles.NA_ADMIN);
    }
    shouldDisableRegisterVehicleButton() {
      return !this.isAdministrator;
    }
    shouldDisplayRegisterVehicleButton() {
      return this.displayRegisterVehicleButton;
    }

    handleRegisterVehicleButtonClick() {
      if (this.isAdministrator) {
        this.loadReactComponent(
          {
            onRegistrationSuccess: () => {
              this.scope.$apply(() => this.scope.$emit('vehicleRegistered'));
            },
            language: this.language
          }
        );
      }
    }

    getVehicleRegistrationConfig(userUoId) {
      this.FeatureOuService.getVehicleRegistrationConfig(userUoId).then((vehicleRegistration) => {
        this.displayRegisterVehicleButton = vehicleRegistration;
      }).catch((error) => {
        this.log.error('Error loading featureOu config: ', error);
      });
    }
  }

  VehicleRegistrationController.$inject = ['$scope', '$log', 'Authenticator', 'safetyService', 'FeatureOuService'];
  angular.module('safetyModule').controller('VehicleRegistrationCtrl', VehicleRegistrationController);
}());
